import { useTheme } from '@mui/styles';
import { useSelector } from 'react-redux';
import { selectCompany } from 'src/old/actions/company/companySelectors';
import { type ChartValuesAmount, type ChartValuesCount } from 'src/shared/types/chartsData';
import { type CHART_TYPE } from './types';
import { generateChartDatasets, getChartOptions } from './utils';

export const useChart = (
  chartType: CHART_TYPE,
  data: ChartValuesAmount | ChartValuesCount,
  labels: string[],
  stacked: boolean
) => {
  const { locale, currency } = useSelector(selectCompany) ?? {};
  const theme: any = useTheme();
  const options = getChartOptions(chartType, theme, currency, locale, stacked);
  const chartData = {
    labels,
    datasets: generateChartDatasets(data, chartType, theme)
  };
  return { chartData, options };
};
